<template>
    <div v-if="filteredResults"
			class="results"
			:style="{ height: contentHeight }">
			<div v-for="category in filteredResults"
					:key="category.id"
					class="category-wrap">
				<div v-for="tournament in category.tournaments"
					:key="tournament.id"
					class="tournament-wrap">
					<div class="tournament-header">
						<div class="tournament-header-wrap">
							<div class="flag-wrap">
								<div :class="['flag', categoryIcon(category)]"></div>
							</div>
							<div class="category-tournament-name">
								{{category.name}} - {{tournament.name}}
							</div>
							<div class="date"
                :class="shortClass">
                {{formatDate(utcDate).toUpperCase()}}
              </div>
							<div class="results-header">
								<div v-for="outcome in resultsMap[selectedSport.providerId]"
									:key="outcome.providerId"
									class="results-provider">
									{{outcome.providerId}}
								</div>
							</div>
						</div>
						<div class="matches-wrap">
							<div v-for="match in tournament.matches"
								:key="match.id"
								class="match-wrap">
								<div class="match-time">
									{{ formatTime(match.timestamp) }}
								</div>
								<div class="match-name"
                  :class="shortClass">
									<span :class="match.winner === 0 ? 'text-warning' : ''">
                    {{teamNameHome(match.name)}}
                  </span>
									<span v-if="teamNameAway(match.name)">
                    -
                  </span>
									<span v-if="teamNameAway(match.name)"
                    :class="match.winner === 1 ? 'text-warning' : ''">
                    {{teamNameAway(match.name)}}
                  </span>
								</div>
								<div class="match-results">
									<div v-for="result in match.results"
										:key="result.providerId"
                    :class="result.providerId === 'FT' ? 'text-warning' : ''"
										class="match-result">
										{{result.value}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
</template>

<script>
import { format } from 'date-fns';
import { mapState } from 'vuex';

export default {
  name: 'resultsContent',
  computed: {
    ...mapState([
      'selectedSport',
      'filteredResults',
      'utcDate',
      'resultsMap',
    ]),
    shortClass() {
      const resultsMappper = this.resultsMap[this.selectedSport.providerId]
        || this.resultsMap.default;

      return resultsMappper.length > 6 ? 'short' : '';
    },
  },
  methods: {
    formatDate(date) {
      return format(new Date(date), 'dd. MMMM');
    },
    formatTime(date) {
      return format(new Date(date), 'HH:mm');
    },
    teamNameHome(matchName) {
      return matchName.split('-')[0];
    },
    teamNameAway(matchName) {
      return matchName.split('-')[1] || '';
    },
    categoryIcon(category) {
      if (!category.isoName) return '';

      return `flag-${category.isoName.toLowerCase()}`;
    },
  },
  data() {
    return {
      timeFormat: 'HH:mm',
      dateFromat: 'DD. MMMM',
      contentHeight: `${window.innerHeight - 235}px`,
    };
  },
};
</script>

<style lang="scss">
  @import '../scss/default/flags';
  @import '../scss/themes/themes';

  .results {
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
